module.exports = __webpack_public_path__ + "static/media/wiki-viewer-preview.497ca1b2.png";